/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.badge.ts
 *
 * Messages du badge configurable (2026-09-20) : libellés de profil sur le
 * badge, feuille pliée, écran de réglages /admin/badge-settings, badges en
 * lot par profil et envoi par courriel. Fusionné dans fr.ts.
 *
 * Les libellés de profil sont ceux du BANDEAU imprimé : courts, en
 * majuscules à l'affichage. Ils se surchargent depuis l'écran de réglages.
 *
 * Mikael - chef de projet - 2026-09-20
 */
export const messagesBadgeFr: Record<string, string> = {
  'badge.profil.visitor': 'Visiteur',
  'badge.profil.exhibitor': 'Exposant',
  'badge.profil.workshop_host': 'Animateur',
  // 2026-10-05 (Mika) : « il y a écrit VIP dessus ». Mikael - chef de projet
  'badge.profil.vip': 'VIP',
  'badge.profil.specific_public': 'Public spécifique',
  'badge.profil.student': 'Étudiant',
  'badge.profil.child': 'Enfant',
  'badge.profil.staff': 'Organisation',
  'badge.profil.admin': 'Organisation',
  'badge.profil.plastron': 'Démo',
  // 2026-10-05 : tous les comptes du back-office et l'équipe sans compte.
  'badge.profil.organisation': 'Organisation',
  'badge.aria': 'Badge {role} de {name}',
  'badge.qr.alt': 'Code QR à scanner par les exposants',
  'badge.affiche.alt': 'Affiche de l’événement',

  'badgePrint.helpText.pli':
    'Cette feuille A4 se plie en quatre, face imprimée à l’extérieur : le badge se retrouve à l’endroit devant et derrière, au format du porte-badge A6. Les traits gris marquent les plis.',

  'adminNav.badgeSettings': 'Badges : format et contenu',
  'acces.titre.adminBadgeSettings': 'Badges : format et contenu',

  'badgeSettings.titre': 'Badges : format et contenu',
  'badgeSettings.sousTitre':
    'Ce que les participants impriment chez eux et ce que vous imprimez en lot. Les changements s’appliquent immédiatement à tous les badges.',
  'badgeSettings.format': 'Format',
  'badgeSettings.format.a4_plie_4': 'Feuille A4 pliée en quatre, deux faces A6 portrait (porte-badge A6, 105 × 148 mm)',
  'badgeSettings.format.a6_paysage': 'Une face A6 paysage (148 × 105 mm)',
  'badgeSettings.format.a7_portrait': 'Une face A7 portrait (74 × 105 mm)',
  'badgeSettings.format.cr80': 'Carte CR80 (85,6 × 54 mm)',
  'badgeSettings.format.custom': 'Dimensions libres',
  'badgeSettings.largeur': 'Largeur (mm)',
  'badgeSettings.hauteur': 'Hauteur (mm)',
  'badgeSettings.nom': 'Nom écrit sur le badge',
  'badgeSettings.nom.initiale': 'Prénom et initiale du nom (Anthony D.)',
  'badgeSettings.nom.complet': 'Prénom et nom complet (Anthony Dolcemascolo)',
  'badgeSettings.nom.aide': 'C’est le défaut. Sur « Badges en lot », vous choisissez au moment d’imprimer ou d’envoyer.',
  'badgesLot.nom': 'Nom',
  'badgeSettings.elements': 'Sur le recto',
  'badgeSettings.element.photo': 'Photo de la personne',
  'badgeSettings.element.nom': 'Nom',
  'badgeSettings.element.structure': 'Structure ou entreprise',
  'badgeSettings.element.role': 'Bandeau de profil',
  'badgeSettings.element.qr': 'Code QR',
  'badgeSettings.element.code': 'Numéro de badge',
  'badgeSettings.element.evenement': 'Nom de l’événement',
  'badgeSettings.element.accroche': 'Accroche de l’événement',
  'badgeSettings.element.date_lieu': 'Date et lieu',
  'badgeSettings.verso': 'Au verso',
  'badgeSettings.verso.affiche': 'L’affiche de l’événement, en plein format',
  'badgeSettings.verso.identique': 'Le même badge (lisible des deux côtés)',
  'badgeSettings.verso.qr': 'Le code QR et le nom seulement',
  'badgeSettings.verso.texte': 'Un texte libre (horaires, consignes…)',
  'badgeSettings.verso.vide': 'Rien',
  'badgeSettings.versoTexte': 'Texte du verso',
  'badgeSettings.couleurs': 'Couleurs et libellés par profil',
  'badgeSettings.couleurs.aide':
    'Chaque profil a sa palette par défaut. Modifiez une couleur ou le mot du bandeau, ou revenez au défaut.',
  'badgeSettings.couleur.bg': 'Fond',
  'badgeSettings.couleur.border': 'Bordure et bandeau',
  'badgeSettings.couleur.fg': 'Texte',
  'badgeSettings.couleur.fgBanner': 'Texte du bandeau',
  'badgeSettings.libelle': 'Mot du bandeau',
  'badgeSettings.defaut': 'Revenir au défaut',
  'badgeSettings.apercu': 'Aperçu',
  'badgeSettings.apercu.profil': 'Profil de l’aperçu',
  'badgeSettings.apercu.exemple': 'Exemple : Camille D., Entreprise Exemple',
  'badgeSettings.enregistrer': 'Enregistrer',
  'badgeSettings.enregistre': 'Réglages du badge enregistrés.',
  'badgeSettings.erreur': 'Impossible d’enregistrer les réglages. Réessayez.',
  'badgeSettings.chargement': 'Chargement des réglages…',

  'badgesLot.titre': 'Badges en lot',
  'badgesLot.sousTitre':
    'Imprimez ou envoyez les badges par profil, au format configuré dans « Badges : format et contenu ».',
  'badgesLot.profil': 'Profil',
  'badgesLot.profil.tous': 'Tous les profils',
  'badgesLot.filtre': 'Sélection',
  'badgesLot.filtre.recent': '20 derniers inscrits',
  'badgesLot.filtre.today': 'Inscrits aujourd’hui',
  'badgesLot.filtre.all': 'Tous',
  'badgesLot.filtre.search': 'Recherche',
  'badgesLot.recherche': 'Nom, prénom ou numéro de badge',
  'badgesLot.chercher': 'Afficher',
  'badgesLot.compte': '{n, plural, =0 {Aucun badge} one {# badge} other {# badges}}',
  'badgesLot.imprimer': 'Imprimer',
  'badgesLot.imprimerAide':
    '{n, plural, one {# feuille} other {# feuilles}} au format configuré. Une feuille A4 pliée par personne.',
  'badgesLot.vide': 'Aucun compte ne correspond à la sélection.',
  'badgesLot.chargement': 'Chargement…',
  'badgesLot.erreur': 'Impossible de charger les badges.',
  'badgesLot.photoAbsente': 'sans photo',

  'badgesLot.mail.titre': 'Envoyer par courriel',
  'badgesLot.mail.titulaires': 'À chaque titulaire, son badge',
  'badgesLot.mail.titulairesAide':
    'Un courriel par personne de la sélection, avec son badge en PDF. Seules les personnes qui ont une adresse le reçoivent.',
  'badgesLot.mail.imprimeur': 'À une personne chargée de l’impression',
  'badgesLot.mail.imprimeurAide': 'Un seul courriel, avec tous les badges de la sélection dans un PDF.',
  'badgesLot.mail.adresse': 'Adresse de la personne',
  'badgesLot.mail.envoyerTitulaires': 'Envoyer à {n, plural, one {# personne} other {# personnes}}',
  'badgesLot.mail.envoyerImprimeur': 'Envoyer le lot',
  'badgesLot.mail.confirmerTitulaires':
    'Envoyer son badge par courriel à chacune des {n} personnes de la sélection ?',
  'badgesLot.mail.envoye': '{envoyes} envoyé(s), {ignores} sans adresse, {echecs} échec(s).',
  'badgesLot.mail.envoyeImprimeur': 'Lot de {n} badges envoyé à {email}.',
  'badgesLot.mail.erreur': 'L’envoi a échoué. Réessayez.',
  'badgesLot.mail.adresseInvalide': 'Adresse de courriel invalide.',
  'badgesLot.mail.enCours': 'Envoi en cours…',

  // 2026-10-05 : badges organisation des personnes SANS compte.
  // Mikael - chef de projet - 2026-10-05
  'badgesOrga.titre': 'Badges organisation sans compte',
  'badgesOrga.aide':
    'Bénévoles, accueil, partenaires de l’équipe : ces personnes n’ont pas de compte, mais elles portent un badge ORGANISATION. Leurs badges sortent ci-dessous avec ceux des comptes du back-office, sans code QR.',
  'badgesOrga.prenom': 'Prénom',
  'badgesOrga.nom': 'Nom',
  'badgesOrga.fonction': 'Fonction',
  'badgesOrga.structure': 'Structure (facultative)',
  'badgesOrga.ajouter': 'Ajouter',
  'badgesOrga.enregistrer': 'Enregistrer',
  'badgesOrga.annuler': 'Annuler',
  'badgesOrga.modifier': 'Modifier',
  'badgesOrga.supprimer': 'Supprimer',
  'badgesOrga.supprimerConfirm': 'Supprimer le badge de {nom} ?',
  'badgesOrga.vide': 'Personne pour le moment.',
  'badgesOrga.ok.create': 'Personne ajoutée.',
  'badgesOrga.ok.update': 'Modification enregistrée.',
  'badgesOrga.ok.delete': 'Personne retirée.',
  'badgesOrga.erreur': 'L’opération n’a pas abouti.',
};
